import {defineStore} from 'pinia';
import axios from "axios";
import Cookie from "js-cookie";

export const useLocalizeStore = defineStore('localizeStore', {
	state: () => ({
		defaultLangSource: 'hu',
		currentLangSource: Cookie.get('locale') ?? 'hu',
		translateKeyPairList: [],
		languages: [],
		loaded: false,
	}),
	actions: {
		async getTranslationList() {
			this.loaded = false;
			let currentLang = Cookie.get('locale') ?? 'hu';
			axios.get(`/api/localize/${currentLang}`).then(response => {
				this.translateKeyPairList = response.data.localize;
				this.languages = response.data.langs;
				this.loaded = true;
			});
		},
	},
	getters: {
		defaultLang: state => state.defaultLangSource,
		currentLang: state => state.currentLangSource,
		translateList: state => state.translateKeyPairList,
		languageList: state => state.languages,
		isLoaded: (state): boolean => state.loaded,
	}
})

